import React, { useState, useEffect, useRef } from "react";
import Lottie from "react-lottie-player";
import { cn } from "../lib/helpers";
import styles from "./lottie-section.module.css";
import PropTypes from "prop-types";
import useOnScreen from "../lib/useOnScreen";

const LottieSection = (props) => {
  const {
    lottieFile,
    loop,
    disablePadding,
    widthMode,
    widthPercent,
    mobileWidthPercent,
    widthPixels,
    mobileWidthPixels,
  } = props;
  const [animationData, setAnimationData] = useState(null);
  const [animationComplete, setAnimationComplete] = useState(false);
  const ref = useRef();
  const isVisible = useOnScreen(ref);

  // Coerce to an explicit boolean: Sanity's `loop` field is `undefined` (not
  // `false`) until someone actually toggles it, and react-lottie-player's own
  // default for an `undefined` `loop` prop is `true` (React falls back to a
  // component's defaultProps whenever a prop is explicitly `undefined`) — so
  // an untouched Studio field was silently looping instead of playing once.
  const defaultOptions = {
    loop: Boolean(loop),
  };

  // Only ever read the field(s) that belong to the currently selected width
  // mode, so a stale value left in a hidden field from a previous mode can
  // never affect what actually renders.
  let desktopWidth = "100%";
  let mobileWidth = "100%";
  if (widthMode === "percent") {
    desktopWidth = `${widthPercent}%`;
    mobileWidth = mobileWidthPercent ? `${mobileWidthPercent}%` : desktopWidth;
  } else if (widthMode === "pixels") {
    desktopWidth = `${widthPixels}px`;
    mobileWidth = mobileWidthPixels ? `${mobileWidthPixels}px` : "100%";
  }

  useEffect(() => {
    const fetchData = async () => {
      const response = await fetch(lottieFile.asset.url);
      let responseJson = await response.json();

      setAnimationData(responseJson);
    };
    fetchData();
  }, []);

  return (
    <div className={cn(styles.root, disablePadding ? styles.disablePadding : "")} ref={ref}>
      {animationData && (
        <div
          className={styles.lottieWrapper}
          style={{ "--lottie-width-mobile": mobileWidth, "--lottie-width-desktop": desktopWidth }}
        >
          <Lottie
            {...defaultOptions}
            play={isVisible && (loop || !animationComplete)}
            animationData={animationData}
            onComplete={() => setAnimationComplete(true)}
            style={{ width: "100%", height: "auto" }}
          />
        </div>
      )}
    </div>
  );
};

LottieSection.propTypes = {
  lottieFile: PropTypes.object,
  loop: PropTypes.bool,
  widthMode: PropTypes.string,
  widthPercent: PropTypes.number,
  mobileWidthPercent: PropTypes.number,
  widthPixels: PropTypes.number,
  mobileWidthPixels: PropTypes.number,
};

export default LottieSection;
